import { useQueries } from "react-query";
import { fetchIngredientPosts } from "./useGetIngredientPosts";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { IngredientPostSchema, IngredientPost } from "./useGetSomeIngredientPosts";

export const getIngredientsPostsApiKey = "getIngredientsPosts" as const;

export const useGetIngredientsPosts = (ingredientIds: number[], campaignId?: number) => {
    const queries = useQueries(
        ingredientIds.map((ingredientId) => ({
            queryFn: async () => {
                const ingredientsPosts = await fetchIngredientPosts(ingredientId, campaignId);
                const post = zodParseWithLog(
                    ingredientsPosts.data,
                    IngredientPostSchema.array(),
                    getIngredientsPostsApiKey,
                );
                return post;
            },
            queryKey: [getIngredientsPostsApiKey, ingredientId, campaignId],
        })),
    );

    const acc: { hasAllLoaded: boolean; posts: IngredientPost[] } = { hasAllLoaded: true, posts: [] };
    const data = queries.reduce((prevAcc, query) => {
        if (query.isLoading) {
            prevAcc["hasAllLoaded"] = false;
        }

        if (query.data !== undefined) {
            query.data.map((oneIngPost) => {
                prevAcc["posts"].push(oneIngPost);
            });
        }

        return prevAcc;
    }, acc);

    return {
        posts: data.posts,
        hasAllLoaded: data.hasAllLoaded,
        ...queries,
    };
};
